import _ from 'lodash'
import { createActions, handleActions } from 'redux-actions'
import fetch from 'isomorphic-fetch'

const { REACT_APP_API_HOST } = process.env

export const companiesRoute = {
  domain: REACT_APP_API_HOST,
  path: '/api/companies?valid=false',
}

export const initialState = {
  isFetching: false,
  items: {},
}

// Actions
export const REQUEST_STATUS = 'REQUEST_STATUS'
export const RECEIVE_STATUS = 'RECEIVE_STATUS'

// Reducer
const reducer = handleActions(
  {
    [REQUEST_STATUS]: state => ({ ...state, isFetching: true }),
    [RECEIVE_STATUS]: (state, { payload: { companies, receivedAt } }) => ({
      ...state,
      isFetching: false,
      items: _.keyBy(companies, 'id'),
      lastUpdated: receivedAt,
    }),
  },
  initialState
)
export default reducer

// Action creators
export const { requestStatus, receiveStatus } = createActions(
  {
    [RECEIVE_STATUS]: companies => ({
      companies,
      receivedAt: Date.now(),
    }),
  },
  REQUEST_STATUS
)

export function fetchStatus() {
  return dispatch => {
    dispatch(requestStatus())
    return fetch(`${companiesRoute.domain}${companiesRoute.path}`)
      .then(
        response => response.json(),
        error => console.log('An error occured', error)
      )
      .then(json => dispatch(receiveStatus(json)))
  }
}
